import React, { useEffect, useState } from 'react';
import InputElement from '../Components/InputElement'
import { useRecoilState, useRecoilValue } from 'recoil';
import { ActiveEvents, pageDetails, toaster } from '../Recoil/ActiveEvents';
import InputSelectBox from '../Components/InputSelectBox';
import ConfirmationPopup from '../Components/ConfirmationPopup';
import { useParams } from 'react-router-dom';
import UserConfirmationPopup from '../Components/UserConfirmationPopup';
const RegisterForm = () => {
  const selectedEvent = useRecoilValue(pageDetails);
  const eventDetails = useRecoilValue(ActiveEvents);
  const [proofTypes, setProofTypes] = useState([]);
  const [eventType, setEventType] = useState([]);
  const [bloodGroup, setBloodGroup] = useState([{BloodGroup:"A+"},{BloodGroup:"A-"},{BloodGroup:"B+"},{BloodGroup:"B-"},{BloodGroup:"AB+"},{BloodGroup:"AB-"},{BloodGroup:"O+"},{BloodGroup:"O-"}]);
  const [tShirt , setTShirt] = useState([{TShirtSize:'S'},{TShirtSize:'M'},{TShirtSize:'L'},{TShirtSize:'XL'},{TShirtSize:'2XL'},{TShirtSize:'3XL'},{TShirtSize:'4XL'}]);
  const selectedEventName = eventDetails.length > selectedEvent.currentIndex? eventDetails[selectedEvent.currentIndex].EventName:'' ;
  const selectedEventID = eventDetails.length > selectedEvent.currentIndex? eventDetails[selectedEvent.currentIndex].EventId:'' ;
  const { id } = useParams();
  const [agree, setAgree] = useState(false);
  const [registrationFormData, setRegistrationFormData] = useState({
    EventId:'',
    EventDescription:'',
    FirstName: '',
    LastName: '',
    Emailid: '',
    MobileNo:'',
    Gender:'',
    DOB:'',
    Address:'',
    City:'',
    Pincode:'',
    State:'Tamilnadu',
    EventName: selectedEventName ,
    EventType:'',
    IdProofType: '',
    IdProofNumber: '',
    BloodGroup:'',
    EmergencyContactNumber:'',
    TShirtSize:'',
    NameToDisplayInTshort:''
  });
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [showUser, setshowUser] = useState(true);
  const [enablePayment,setEnablePayment] = useState(false);
  const [getUserForm, setGetUserForm] = useState({EmailId:'',MobileNo:'',"RegistrationId":"",});
  const [notify, setNotify] = useRecoilState(toaster);
  const [confirm, setConfirm] = useState(false);
  useEffect(() => {
    let eventURI = process.env.REACT_APP_API_URL +"/GetIdProof";
    fetch(eventURI ,  {
      method: "GET",
      headers: {"Content-Type": "application/json"}})
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((result) =>{
      setProofTypes(result.IDProofType)
    }
    )
    .catch((error) => console.error(error));
    let evtID = !!selectedEventID ? selectedEventID : id
    let getEventDetails = process.env.REACT_APP_API_URL +"/Events/GetEventDetails";
    fetch(getEventDetails ,  {
      method: "POST",
      body: JSON.stringify(evtID),
      headers: {"Content-Type": "application/json"}})
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((result) =>{
      let evtDetails = !!result && result.Events.length > 0 ? result.Events[0].EventDetails : [];
      setEventType(evtDetails)
      // setProofTypes(result.IDProofType)
    }
    )
    .catch((error) => console.error(error));
  }, []);

  const handleRegChange = (e) => {
    const { name, value, datakey } = e.target;
    // if(name == "EventType"){
    //   let eventonbj = eventType.find( (obj)=> obj.EventId == value);
    //   setRegistrationFormData({ ...registrationFormData, 'EventId': eventonbj?.EventId || '', "EventName": eventonbj?.EventName || '', "EventDescription": eventonbj?.EventDescription ||'' });
    // }else 
    if(name == "EventName"){
      let eventonbj = eventDetails.find( (obj)=> obj.EventId == value);
      setRegistrationFormData({ ...registrationFormData, 'EventId': eventonbj?.EventId || '', "EventName": eventonbj?.EventName || '', "EventDescription": eventonbj?.EventDescription ||'' });
    }else{
      setRegistrationFormData({ ...registrationFormData, [name]: value });
    }
  };
  // Validate form data
  const validate = () => {
    const newErrors = {};
    const phonePattern = /^[0-9]{10}$/;
    if (registrationFormData.FirstName.trim() === '') {
      newErrors.FirstName = 'FirstName is required';
    } else if (registrationFormData.FirstName.length < 5) {
      newErrors.FirstName = 'FirstName must be at least 5 characters';
    }
    if (registrationFormData.LastName.trim() === '') {
      newErrors.LastName = 'LastName is required';
    } else if (registrationFormData.LastName.length < 1) {
      newErrors.LastName = 'LastName must be at last 1 characters';
    }
    if (registrationFormData.Emailid.trim() === '') {
      newErrors.Emailid = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(registrationFormData.Emailid)) {
      newErrors.Emailid = 'Email is invalid';
    }
    if (registrationFormData.MobileNo.trim() === '') {
      newErrors.MobileNo = 'MobileNo is required';
    } else if (!phonePattern.test(registrationFormData.MobileNo.trim())) {
      newErrors.MobileNo = 'Mobile Number must be 10 digits';
    }
    if (registrationFormData.Gender.trim() === '') {
      newErrors.Gender = 'Gender is required';
    }
    if (registrationFormData.DOB.trim() === '') {
      newErrors.DOB = 'Date of Birth is required';
    }
    if (registrationFormData.Address.trim() === '') {
      newErrors.Address = 'Address is required';
    }
    if (registrationFormData.City.trim() === '') {
      newErrors.City = 'City is required';
    }
    if (registrationFormData.Pincode.trim() === '') {
      newErrors.Pincode = 'Pincode is required';
    }else if (registrationFormData.Pincode.length < 5) {
      newErrors.Pincode = 'Pincode must be at least 5 characters';
    }
    if (registrationFormData.State.trim() === '') {
      newErrors.State = 'State is required';
    }
    if (registrationFormData.EventName.trim() === '') {
      newErrors.EventName = 'Event Name is required';
    }
    if (registrationFormData.EventType.trim() === '') {
      newErrors.EventType = 'Event Type is required';
    }
    if (registrationFormData.TShirtSize.trim() === '') {
      newErrors.TShirtSize = 'TShirtSize is required';
    }
    if (registrationFormData.IdProofNumber.trim() === '') {
      newErrors.IdProofNumber = 'Id Proof Type is required';
    }
    if (registrationFormData.IdProofType.trim() === '') {
      newErrors.IdProofType = 'Id Proof Type is required';
    }
    if (registrationFormData.BloodGroup.trim() === '') {
      newErrors.BloodGroup = 'Id Proof Type is required';
    }
    // if (registrationFormData.NameToDisplayInTshort.trim() === '') {
    //   newErrors.NameToDisplayInTshort = 'Id Proof Type is required';
    // }else if (registrationFormData.NameToDisplayInTshort.length < 5) {
    //   newErrors.NameToDisplayInTshort = 'Name must be at least 5 characters';
    // }
    if (registrationFormData.EmergencyContactNumber.trim() === '') {
      newErrors.EmergencyContactNumber = 'Emergency Contact Number is required';
    } else if (!phonePattern.test(registrationFormData.EmergencyContactNumber.trim())) {
      newErrors.EmergencyContactNumber = 'Emergency Contact Number Number must be 10 digits';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRegistrationSubmit = (e) => {
    e.preventDefault();
    if(!agree){
      let tampObj = {'showPopup': true, 'message': "Please agree to the terms and conditions.", type:'error'}
      setNotify(tampObj)
      return;
    } 
    if (validate()) {
      setConfirm(true);
    }else{
      let tampObj = {'showPopup': true, 'message': "Please fill in all mandatory fields.", type:'error'}
      setNotify(tampObj)
    }

  };

  const intiateUserRegister = (e) => {
    setConfirm(false);
      registrationFormData.Status='A';
      registrationFormData.Country='IN';
      registrationFormData.PaymentId=null;
      let eventURI = process.env.REACT_APP_API_URL +"/Registration/EventRegistration";
      fetch(eventURI , {
        method: "POST",
        headers: {
        "Content-Type": "application/json"},
        body: JSON.stringify(registrationFormData),
      })
      .then((response) =>{
        const contentType = response.headers.get("Content-Type");
        if (contentType && contentType.includes("application/json")) {
          return response.json();
        } else {
          return response.text();
        }
      })
      .then((result) => {
        if(!!result.Registration && result.Registration.length > 0 && result.Registration[0].ErrorMessage == "Success"){
          let eventFee = !!eventType && eventType.length>0 ?  eventType.find( (obj)=> obj.EventDetailsId == registrationFormData.EventType) : null;
          if(eventFee != null){
            intiatePayment(result.Registration[0].NewId, eventFee.Amount)
          }else{
            let errmsg = 'User payment failed'
            let tampObj = {'showPopup': true, 'message': errmsg, type:'warning'}
            setNotify(tampObj)
          }

        }else{
          let errmsg = !!result.Registration && result.Registration.length > 0 ? result.Registration[0].ErrorMessage : 'Event registration failed'
          let tampObj = {'showPopup': true, 'message': errmsg, type:'warning'}
          setNotify(tampObj)
        }
      }
      ) 
      .catch((error) => console.error(error));
  }

  const intiatePayment = (userID, eventFee)=>{
    let registredUserID = userID
    setEnablePayment(true);
    var options = {
       key:"rzp_live_VWk8aGK4iiUR6z",
       key_secret:"vRL1aos64gLt6hodDnSdD6OR",
     // key:"rzp_test_srWRviTG6uwcbU",
     // key_secret:"4LfZlw61ECp8BTG7aNDqTFky",
      amount: eventFee * 100,
      currency:"INR",
      name:"Kalingarayan Runners",
      description: "Kalingarayan Runners 2025",
      handler:function(response){
        let paymentID = response.razorpay_payment_id
       updatePaymentDetails(registredUserID,paymentID);
       AutendicatePayment(paymentID)
        // console.log(registredUserID)
        // setSuccess(true);
        // alert(response.razorpay_payment_id);
        // console.log(response);

      },
      prefill:{
       
      },
      notes:{
        address:"Erode"
      },
      theme:{
        color:"#fff"
      }
    };
    var pay = new window.Razorpay(options); 
    pay.open();
  }

  const AutendicatePayment = (payid) =>{
    let eventURI = process.env.REACT_APP_API_URL +"/Registration/CapturePayment";
    fetch(eventURI , {
      method: "POST",
      headers: {
      "Content-Type": "application/json"},
      body: JSON.stringify(payid),
    })
    .then((response) =>{
      const contentType = response.headers.get("Content-Type");
      if (contentType && contentType.includes("application/json")) {
        return response.json();
      } else {
        return response.text();
      }
    })
    .then((result) => {
      setSuccess(true);
    }
    ) 
    .catch((error) => console.error(error));
  }
  const updatePaymentDetails = (userID, paymentID) =>{
    let eventURI = process.env.REACT_APP_API_URL +"/Registration/UpdatePayment";
    fetch(eventURI , {
      method: "POST",
      headers: {
      "Content-Type": "application/json"},
      body: JSON.stringify({"PaymentId": paymentID,"RegistrationId": userID}),
    })
    .then((response) =>{
      const contentType = response.headers.get("Content-Type");
      if (contentType && contentType.includes("application/json")) {
        return response.json();
      } else {
        return response.text();
      }
    })
    .then((result) => {
      setSuccess(true);
    }
    ) 
    .catch((error) => console.error(error));
  }

  const updateValue = () => {
    Object.keys(registrationFormData).forEach(key => {
      registrationFormData[key] = ''; 
    });
    registrationFormData.EventName = selectedEventName;
    setTimeout(() => {
      setSuccess(false);
      setErrors({});
    }, 300);
  }
  const handleFetchUser = (e)=>{
    e.preventDefault();
    if (validateUserForm()) {
      let eventURI = process.env.REACT_APP_API_URL +"/Registration/GetRegistrationDetails";
      fetch(eventURI , {
        method: "POST",
        headers: {
        "Content-Type": "application/json"},
        body: JSON.stringify(getUserForm),
      })
      .then((response) => response.json())
      .then((result) => {
        let tempObj = !!result.RegistrationDetails ? result.RegistrationDetails[0] : {}
        // Object.assign({}, registrationFormData, tempObj)
        tempObj.EventName = selectedEventName
        setRegistrationFormData((registrationFormData) => ({
          ...registrationFormData,
          ...tempObj,
        }));
        setshowUser(false);
      })
      .catch((error) => console.error(error));
    }
  }
  const validateUserForm = ()=>{
    const phonePattern = /^[0-9]{10}$/;
    const newErrors = {};
    if (getUserForm.EmailId.trim() === '') {
      newErrors.EmailId = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(getUserForm.EmailId)) {
      newErrors.EmailId = 'Email is invalid';
    }
    if (getUserForm.MobileNo.trim() === '') {
      newErrors.MobileNo = 'MobileNo is required';
    } else if (!phonePattern.test(getUserForm.MobileNo.trim())) {
      newErrors.MobileNo = 'Mobile Number must be 10 digits';
    }
    let err = Object.keys(newErrors).length === 1 ? {} : newErrors;
    setErrors(err);
    return Object.keys(err).length === 0;
  }

  const handleUserChange = (e)=>{
    const { name, value } = e.target;
    setGetUserForm({ ...getUserForm, [name]: value });
//    setRegistrationFormData({ ...registrationFormData, [name]: value });
  }


  return <div className='max-w-[1024px] mx-auto px-4 pt-12'>
    <div>
        <h2 className='text-dark-gray text-2xl font-medium'>Registration Details</h2>
        <h4>Ready, Set, Go! Register for the Marathon</h4>
            {!!showUser &&(
            <div>
                <form onSubmit={handleFetchUser} className="space-y-4 pt-7" id="regForm">
                  <div className="grid grid-cols-1 md:grid-cols-[1fr_0.05fr_1fr] lg:grid-cols-[1fr_0.05fr_1fr] gap-4">
                    {/* row 1 */}
                      <div >
                        <InputElement value={getUserForm.EmailId} errors={errors.EmailId} Label='EmailId' elementName='EmailId'  handleRegChange = {(e)=>handleUserChange(e)}/>
                      </div>
                      <div className='sm:p-0 md:p-8'>
                        <span >or</span>
                      </div>
                      <div className=''>
                        <InputElement value={getUserForm.MobileNo} errors={errors.MobileNo} Label='Phone Number' elementName='MobileNo'  handleRegChange = {(e)=>handleUserChange(e)}/>
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="bg-red-600 text-white py-2 px-8 font-medium rounded-md shadow focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-75"
                    >
                      Get Saved Details
                    </button>
                </form>
            </div>
            )}
          {!showUser &&(
            <div>
              <form onSubmit={handleRegistrationSubmit} className="space-y-4 pt-7" id="regForm">
                <div className="grid grid-cols-1 md:grid-cols-2 md:grid-cols-2 gap-4">
                  {/* row 1 */}
                    <div>
                      <InputElement value={registrationFormData.FirstName} errors={errors.FirstName} Label='Full Name *' elementName='FirstName'  handleRegChange = {(e)=>handleRegChange(e)}/>
                    </div>
                    <div>
                      <InputElement value={registrationFormData.LastName} errors={errors.LastName} Label='Last Name *' elementName='LastName'  handleRegChange = {(e)=>handleRegChange(e)}/> 
                    </div>
                    {/* row 2 */}
                    <div>
                      <InputElement value={registrationFormData.Emailid} errors={errors.Emailid} Label='Email Address' elementName='Emailid'  handleRegChange = {(e)=>handleRegChange(e)}/> 
                    </div>
                    <div>
                      <InputElement value={registrationFormData.MobileNo} errors={errors.MobileNo} Label=' Phone Number' elementName='MobileNo'  handleRegChange = {(e)=>handleRegChange(e)}/> 
                    </div>
                    {/* row 3 */}
                      <div>
                        <label htmlFor="name" className="block text-sm font-medium text-label-clr pl-1">
                        Gender
                        </label>
                        <div className="flex items-center pt-3 space-x-4 pl-2">
                            <div className="flex items-center">
                              <input
                                type="radio"
                                id="Male"
                                name= "Gender"
                                value="Male"
                                className="h-4 w-4 border-2 border-orenge rounded-full appearance-none checked:bg-orenge focus:ring-2 focus:ring-green-400"
                                onChange={handleRegChange}
                                checked={registrationFormData.Gender === 'Male'} 
                              />
                              <label htmlFor="Male" className="ml-2 text-sm text-gray-700">
                                Male
                              </label>
                            </div>

                            <div className="flex items-center">
                              <input
                                type="radio"
                                id="Female"
                                name="Gender"
                                value="Female"
                                className="h-4 w-4 border-2 border-orenge rounded-full appearance-none checked:bg-orenge focus:ring-2 focus:ring-green-400"
                                onChange={handleRegChange}
                                checked={registrationFormData.Gender === "Female"} 
                              />
                              <label htmlFor="Female" className="ml-2 text-sm text-gray-700">
                              Female
                              </label>
                            </div>
                            {errors.Gender && (
                              <p className="text-red-500 text-sm mt-1">{errors.Gender}</p>
                            )}
                        </div>
                      </div>
                      <div>
                        <InputElement value={registrationFormData.DOB} errors={errors.DOB} Label='Date of Birth' elementName='DOB'  handleRegChange = {(e)=>handleRegChange(e)}/> 
                      </div>
                </div>
                <h4>Address & Personal Details</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 md:grid-cols-2 gap-4">
                  {/* row 1 */}
                    <div>
                      <InputElement value={registrationFormData.Address} errors={errors.Address} Label='Street Name' elementName='Address'  handleRegChange = {(e)=>handleRegChange(e)}/> 
                    </div>
                    <div>
                        <InputElement value={registrationFormData.City} errors={errors.City} Label='City' elementName='City'  handleRegChange = {(e)=>handleRegChange(e)}/> 
                    </div>
                    {/* row 2 */}
                    <div>
                        <InputElement value={registrationFormData.Pincode} errors={errors.Pincode} Label='Pincode' elementName='Pincode'  handleRegChange = {(e)=>handleRegChange(e)}/> 
                    </div>
                    <div>
                      <InputElement value={registrationFormData.State} errors={errors.State} Label=' State' elementName='State'  handleRegChange = {(e)=>handleRegChange(e)}/> 
                    </div>
                    {/* row 3 */}
                    <div>
                      <InputSelectBox  errors={errors.EventName} Label='Name of the Event' elementName='EventName' handleRegChange = {(e)=>handleRegChange(e)} value={registrationFormData.EventId} arrOptions={eventDetails} type="EventName"/>
                      {/* <InputElement value={registrationFormData.} errors={errors.EventName} Label='Name of the Event' elementName='EventName'  handleRegChange = {(e)=>handleRegChange(e)}/> */}
                    </div>
                    <div>
                      <InputSelectBox  errors={errors.EventType} Label='Event Distance' elementName='EventType' handleRegChange = {(e)=>handleRegChange(e)} value={registrationFormData.EventType} arrOptions={eventType} type="RunningDistance"/>
                    </div>
                    <div>
                    <InputSelectBox  errors={errors.TShirtSize}  Label='T-shirt size'  elementName='TShirtSize' handleRegChange = {(e)=>handleRegChange(e)}  value={registrationFormData.TShirtSize} arrOptions={tShirt} type="TShirtSize"/>
                      {/* <InputElement value={registrationFormData.TShirtSize} errors={errors.TShirtSize} Label=' T-shirt  size' elementName='TShirtSize' handleRegChange = {(e)=>handleRegChange(e)}/> */}
                    </div>  
                    {/* row 4 */}
                    <div>
                    <InputSelectBox  errors={errors.IdProofType} Label=' ID- Proof Type' elementName='IdProofType'  handleRegChange = {(e)=>handleRegChange(e)} value={registrationFormData.IdProofType} arrOptions={proofTypes} type="IdProofType"/>
                      {/* <InputElement value={registrationFormData.} errors={errors.IdProofType} Label=' ID- Proof Type' elementName='IdProofType'  handleRegChange = {(e)=>handleRegChange(e)}/> */}
                    </div>
                    <div>
                      <InputElement value={registrationFormData.IdProofNumber} errors={errors.IdProofNumber} Label='ID proof #' elementName='IdProofNumber'  handleRegChange = {(e)=>handleRegChange(e)} />
                    </div>  
                    {/* row 5 */}
                  
                    <div>
                    <InputSelectBox  errors={errors.BloodGroup} Label='Blood Group' elementName='BloodGroup'  handleRegChange = {(e)=>handleRegChange(e)} value={registrationFormData.BloodGroup} arrOptions={bloodGroup} type="BloodGroup"/>

                      {/* <InputElement value={registrationFormData.BloodGroup} errors={errors.BloodGroup} Label='Blood Group' elementName='BloodGroup'  handleRegChange = {(e)=>handleRegChange(e)}/>              */}
                    </div>  
                    {/* row 5 */}
                    {/* <div>
                      <InputElement value={registrationFormData.NameToDisplayInTshort} errors={errors.NameToDisplayInTshort} Label='Name to Disaply in T-shrit' elementName='NameToDisplayInTshort'  handleRegChange = {(e)=>handleRegChange(e)}/>
                    </div> */}
                    <div>
                      <InputElement value={registrationFormData.EmergencyContactNumber} errors={errors.EmergencyContactNumber} Label=' Emergency Contact Phone' elementName='EmergencyContactNumber'  handleRegChange = {(e)=>handleRegChange(e)}/>
                    </div>  
                </div>
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="agree"
                    name="agree"
                    className="h-4 w-4 border-gray-300 rounded focus:ring-indigo-500"
                    onChange={(e) => setAgree(e.target.checked)}
                  />
                  <label htmlFor="agree" className="ml-2 text-sm text-dark-gray opacity-60">
                  I agree to the Terms and Conditions.
                  </label>
                </div>
                <div>
                  <button
                    type="submit"
                    className="bg-red-600 text-white py-2 px-8 font-medium rounded-md shadow focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-75"
                  >
                    Register
                  </button>
                </div>
              </form>
            </div>
          )}
        <UserConfirmationPopup popup={confirm} data={registrationFormData} clearValue={()=>setConfirm(false)} submitForm={()=>intiateUserRegister()} events={eventType} />
        <ConfirmationPopup popup={success} message="Thank you for registering! The event details have been successfully sent to your registered email address." clearValue={()=>updateValue()}/>
    </div>
  </div>;
};

export default RegisterForm;